export default __webpack_public_path__ + "static/media/mysql.e0745c74.svg";